import { ThemeBus } from './events-bus.js';

import { EVENTS } from './event-constants.js';

import { updateCartBubble } from './utilities.js';

 

let adding = false;

let noticeTimer;

 

async function cartFetch(url, options, timeout = 12000) {

  const controller = new AbortController();

  const timer = setTimeout(() => controller.abort(), timeout);

 

  try {

    return await fetch(url, {

      ...options,

      signal: controller.signal

    });

  } finally {

    clearTimeout(timer);

  }

}

 

function basketTarget() {

  return Array.from(

    document.querySelectorAll('header [data-drawer-toggle]')

  ).find(button => {

    if (!button.querySelector('[data-cart-bubble]')) return false;

 

    const rect = button.getBoundingClientRect();

 

    return (

      rect.width > 0 &&

      rect.height > 0 &&

      rect.bottom > 0 &&

      rect.top < innerHeight &&

      rect.right > 0 &&

      rect.left < innerWidth

    );

  });

}

 

function announce(message, persistent = false) {

  let notice = document.getElementById('plp-cart-notice');

 

  if (!notice) {

    notice = document.createElement('div');

    notice.id = 'plp-cart-notice';

    notice.setAttribute('role', 'status');

    notice.setAttribute('aria-live', 'polite');

    notice.setAttribute('aria-atomic', 'true');

 

    notice.style.cssText =

      'position:fixed;right:16px;bottom:96px;z-index:1100;' +

      'max-width:calc(100vw - 32px);padding:12px 18px;border-radius:10px;' +

      'background:#182249;color:#fff;font-size:14px;line-height:1.4;' +

      'box-shadow:0 4px 16px #0003;pointer-events:none;';

 

    document.body.append(notice);

  }

 

  clearTimeout(noticeTimer);

  notice.textContent = message;

  notice.hidden = false;

 

  noticeTimer = setTimeout(() => {

    notice.hidden = true;

    notice.textContent = '';

  }, persistent ? 8000 : 3500);

}

 

function imageSnapshot(dialog, button) {

  const gallery = dialog.querySelector('[data-plp-gallery]');

  if (!gallery) return null;

 

  const bounds = gallery.getBoundingClientRect();

  let selected = null;

  let largest = 0;

 

  gallery.querySelectorAll('img').forEach(image => {

    const rect = image.getBoundingClientRect();

 

    const overlap = Math.max(

      0,

      Math.min(rect.right, bounds.right) -

      Math.max(rect.left, bounds.left)

    );

 

    if (overlap > largest) {

      largest = overlap;

 

      selected = {

        src: image.currentSrc || image.src,

        rect

      };

    }

  });

 

  if (selected) {

    const centerY =

      selected.rect.top + selected.rect.height / 2;

 

    if (centerY < 0 || centerY > innerHeight) {

      selected.origin = button.getBoundingClientRect();

    }

  }

 

  return selected;

}

 

async function flyToBasket(snapshot) {

  if (

    !snapshot ||

    matchMedia('(prefers-reduced-motion: reduce)').matches

  ) {

    return;

  }

 

  await new Promise(requestAnimationFrame);

 

  const basket = basketTarget();

  if (!basket || !Element.prototype.animate) return;

 

  const target = (

    basket.querySelector('svg') || basket

  ).getBoundingClientRect();

 

  const source = snapshot.rect;

  const width = Math.min(104, source.width);

  const height = Math.min(

    132,

    width * source.height / source.width

  );

 

  const origin = snapshot.origin || source;

  const left = origin.left + (origin.width - width) / 2;

  const top = origin.top + (origin.height - height) / 2;

 

  if (

    !width ||

    !height ||

    top > innerHeight ||

    top + height < 0

  ) {

    return;

  }

 

  const image = document.createElement('img');

  image.src = snapshot.src;

  image.alt = '';

  image.setAttribute('aria-hidden', 'true');

 

  image.style.cssText =

    `position:fixed;inset:auto;left:${left}px;top:${top}px;` +

    `width:${width}px;height:${height}px;margin:0;padding:0;border:0;` +

    'object-fit:contain;background:white;border-radius:12px;' +

    'pointer-events:none;z-index:2147483647;' +

    'box-shadow:0 8px 24px #0003;';

 

  if (typeof image.showPopover === 'function') {

    image.setAttribute('popover', 'manual');

  } else if (document.querySelector('dialog[open]')) {

    return;

  }

 

  document.body.append(image);

 

  const dx =

    target.left + target.width / 2 - (left + width / 2);

 

  const dy =

    target.top + target.height / 2 - (top + height / 2);

 

  try {

    if (image.hasAttribute('popover')) {

      image.showPopover();

    }

 

    await image.animate(

      [

        {

          transform: 'translate(0, 0) scale(1)',

          opacity: 1

        },

        {

          transform:

            `translate(${dx * .45}px, ` +

            `${Math.max(8 - top, Math.min(dy, 0) - 100)}px) ` +

            'scale(.75)',

          opacity: .95,

          offset: .55

        },

        {

          transform: `translate(${dx}px, ${dy}px) scale(.12)`,

          opacity: 0

        }

      ],

      {

        duration: 650,

        easing: 'cubic-bezier(.25,.6,.3,1)',

        fill: 'forwards'

      }

    ).finished;

 

    basket.querySelector('[data-cart-bubble]')?.animate(

      [

        { transform: 'scale(1)' },

        { transform: 'scale(1.25)' },

        { transform: 'scale(1)' }

      ],

      { duration: 250 }

    );

  } finally {

    image.remove();

  }

}

 

async function refreshBasket(url) {

  // Retry basket reads only, never the add request.

  for (let attempt = 0; attempt < 2; attempt++) {

    try {

      const response = await cartFetch(url, {

        credentials: 'same-origin',

        cache: 'no-store',

        headers: {

          Accept: 'application/json'

        }

      });

 

      if (!response.ok) {

        throw new Error('Basket refresh failed');

      }

 

      const cart = await response.json();

 

      if (!Number.isInteger(cart.item_count)) {

        throw new Error('Invalid basket');

      }

 

      window.__cart = cart;

      updateCartBubble();

 

      return cart;

    } catch (error) {

      if (attempt === 1) throw error;

    }

  }

}

 

function showError(form, message, basketUrl) {

  const product = form.closest('[data-plp-dialog-product]');

  const status = product?.querySelector('[data-plp-status]');

 

  if (!status?.isConnected) {

    announce(message, true);

    return;

  }

 

  status.textContent = message;

 

  if (basketUrl) {

    const link = document.createElement('a');

    link.href = basketUrl;

    link.textContent = 'Check your basket';

    link.className = 'plp-test-full-details';

 

    status.append(' ', link);

  }

}

 

window.addEventListener('submit', async event => {

  const form = event.target;

 

  if (

    !(form instanceof HTMLFormElement) ||

    !form.matches('.plp-test-form')

  ) {

    return;

  }

 

  const dialog = form.closest('dialog.plp-test-dialog');

  if (!dialog?.open) return;

 

  event.preventDefault();

  event.stopImmediatePropagation();

 

  const select = form.querySelector('[data-plp-variant]');

  const button = form.querySelector('[data-plp-add]');

 

  if (

    !select?.value ||

    select.disabled ||

    select.selectedOptions[0]?.disabled ||

    !button ||

    button.disabled

  ) {

    return;

  }

 

  if (

    dialog.querySelector('[data-plp-dialog-body]')

      ?.getAttribute('aria-busy') === 'true'

  ) {

    return;

  }

 

  if (adding || form.dataset.submitting === 'true') return;

 

  const addUrl = new URL(form.action, location.href);

 

  if (

    addUrl.origin !== location.origin ||

    !/\/cart\/add\/?$/.test(addUrl.pathname)

  ) {

    return;

  }

 

  addUrl.pathname = addUrl.pathname.replace(

    /\/add\/?$/,

    '/add.js'

  );

  addUrl.search = '';

  addUrl.hash = '';

 

  const cartUrl = new URL(addUrl);

  cartUrl.pathname = cartUrl.pathname.replace(

    /\/add\.js$/,

    '.js'

  );

 

  const basketUrl = new URL(cartUrl);

  basketUrl.pathname = basketUrl.pathname.replace(/\.js$/, '');

 

  const data = new FormData(form);

  data.delete('return_to');

 

  const snapshot = imageSnapshot(dialog, button);

  const originalText = button.textContent;

  let added = false;

 

  adding = true;

  form.dataset.submitting = 'true';

  form.setAttribute('aria-busy', 'true');

 

  button.disabled = true;

  button.textContent = 'Adding…';

  select.disabled = true;

 

  const status = form.closest('[data-plp-dialog-product]')

    ?.querySelector('[data-plp-status]');

 

  if (status) status.textContent = '';

 

  try {

    const response = await cartFetch(

      addUrl,

      {

        method: 'POST',

        credentials: 'same-origin',

        headers: {

          Accept: 'application/json'

        },

        body: data

      },

      20000

    );

 

    const result = await response.json().catch(() => ({}));

 

    if (!response.ok) {

      const error = new Error(

        typeof result.description === 'string'

          ? result.description

          : 'This item could not be added. Please check its availability.'

      );

 

      error.definite =

        response.status >= 400 && response.status < 500;

 

      throw error;

    }

 

    added = true;

 

    if (

      form.isConnected &&

      dialog.open &&

      dialog.contains(form)

    ) {

      dialog.close();

    }

 

    await flyToBasket(snapshot).catch(() => {});

 

    // Let the theme's existing cart system refresh the basket and drawer.

    ThemeBus.dispatchEvent(new Event(EVENTS.cartUpdated));

 

    announce('Added to basket.');

  } catch (error) {

    if (added) {

      announce(

        'Added to basket. The basket display could not refresh.',

        true

      );

    } else {

      showError(

        form,

        error.definite

          ? error.message

          : 'We could not confirm whether it was added. Check your basket before trying again.',

        error.definite ? null : basketUrl.href

      );

 

      refreshBasket(cartUrl).catch(() => {});

      ThemeBus.dispatchEvent(new Event(EVENTS.cartUpdated));

    }

  } finally {

    adding = false;

    delete form.dataset.submitting;

    form.removeAttribute('aria-busy');

 

    select.disabled = false;

    button.textContent = originalText;

    button.disabled =

      !select.value ||

      Boolean(select.selectedOptions[0]?.disabled);

  }

}, true);